export default "__VITE_ASSET__CQksYQXd__"